import "react/jsx-runtime";
import { createContext as t, useContext as o } from "react";
import "@nextgen-web-framework/core";
import { UserType as s } from "./types/propsType.js";
import { AccountType as u } from "./types/propsType.js";
const i = t({
  session: {},
  updateSession: () => {
  }
});
function m() {
  const { session: e } = o(i);
  return { session: e, isAnonymous: () => !e.type || e.type === s.ANONYMOUS, isRegistered: () => e.type === s.REGISTERED, isABO: () => e.type === s.ABO, isMember: () => e.type === s.MEMBER, isEmployee: () => e.type === s.EMPLOYEE, isActor: () => !!e.act };
}
export {
  u as AccountType,
  s as UserType,
  m as useSession
};
//# sourceMappingURL=SessionProvider.js.map
